module.exports = __webpack_public_path__ + "static/media/08_Title-fr.8c6d45df.png";